import Spinner from "@components/icons/Spinner"
import Check from "@components/icons/Check"
import { Button } from "@components/ui/base/button"
import { formatBlockscanUrl } from "@src/lib/formatBlockscanUrl"
import { useSliceContext } from "@components/SliceProvider"

type Props = {
  initCondition: boolean
  uploadState: string
  endState?: string | JSX.Element
  nullCondition?: boolean
  waitingState?: string
}

const LoadingStep = ({
  initCondition,
  uploadState,
  endState = uploadState,
  nullCondition = false,
  waitingState = "Waiting..."
}: Props) => {
  return (
    <>
      <div className="sl-flex sl-items-center sl-justify-center">
        {!nullCondition ? (
          initCondition ? (
            <Spinner />
          ) : (
            <Check className="sl-text-green-500" />
          )
        ) : null}
      </div>
      <div className="sl-col-span-5 sl-ml-2 sl-text-left">
        <p className={nullCondition ? "sl-text-gray-400" : ""}>
          {!nullCondition
            ? initCondition
              ? uploadState
              : endState
            : waitingState}
        </p>
      </div>
    </>
  )
}
export const CREATE_PRODUCT_VIEW = (params: any) => {
  const { uploadStep, uploadPct, cloneAddress, strategyLabel } = params
  const { appChainId, setModalView } = useSliceContext()

  const processing = uploadStep !== 10

  let uploadState: string
  switch (uploadStep) {
    case 1:
      uploadState = "Uploading image"
      break
    case 2:
      uploadState = "Saving metadata"
      break
    case 3:
      uploadState = "Encrypting files"
      break
    case 4:
      uploadState = `Uploading files: ${uploadPct < 100 ? uploadPct : 100}%`
      break
    case 5:
      uploadState = "Finishing setting up"
      break
    case 6:
      uploadState = "Deploying action ..."
      break
    case 7:
      uploadState = "Transaction in progress ..."
      break
    case 8:
      uploadState = `Configuring ${strategyLabel} ...`
      break
    case 9:
      uploadState = "Reverting"
      break
    case 10:
      uploadState = "Done, reverted!"
      break
    case 11:
      uploadState = "Finalizing"
      break
    case 12:
      uploadState = "Almost done"
      break
  }
  return (
    <div className="sl-text-center">
      <div className="sl-pb-8 sl-text-center">
        <h1 className="sl-fonts">Creating product</h1>
      </div>
      <div className="sl-grid sl-items-center sl-grid-cols-6 sl-gap-2 sl-px-4">
        <LoadingStep
          initCondition={uploadStep < 3}
          uploadState={uploadState}
          endState="Done"
        />
        <LoadingStep
          nullCondition={uploadStep < 3}
          initCondition={uploadStep < 7}
          uploadState={uploadState}
          waitingState="File upload"
          endState={
            cloneAddress ? (
              <>
                Contract deployed!{" "}
                <a
                  href={formatBlockscanUrl(appChainId, cloneAddress)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sl-highlight"
                >
                  See on block explorer
                </a>
              </>
            ) : (
              "Done"
            )
          }
        />
        <LoadingStep
          nullCondition={uploadStep < 7}
          initCondition={strategyLabel ? uploadStep < 8 : processing}
          uploadState={uploadState}
          waitingState="Blockchain interaction"
          endState={strategyLabel && "Done"}
        />
        {strategyLabel && (
          <LoadingStep
            nullCondition={uploadStep < 8}
            initCondition={processing}
            uploadState={uploadState}
            waitingState="Pricing strategy"
          />
        )}
      </div>
      <div className="sl-pt-10">
        {uploadStep === 10 ? (
          <Button onClick={() => setModalView({ name: "" })}>
            Go back to product
          </Button>
        ) : (
          <p className="sl-max-w-sm sl-mx-auto sl-text-sm sl-font-bold sl-text-yellow-600">
            Please wait until the process is completed
          </p>
        )}
      </div>
    </div>
  )
}

export default CREATE_PRODUCT_VIEW
